import { render, staticRenderFns } from "./BtnAperturas.vue?vue&type=template&id=1acca856&"
import script from "./BtnAperturas.vue?vue&type=script&lang=js&"
export * from "./BtnAperturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports